export type ReconciliationDecision = 'same' | 'keep-local' | 'use-remote';

export function decideDatasetReconciliation(input: {
  baseRevision: number;
  remoteRevision: number;
  localValue: string | null;
  remoteValue: string | null;
  remoteExists: boolean;
}): ReconciliationDecision {
  if (input.localValue === input.remoteValue) return 'same';
  if (!input.remoteExists) return input.baseRevision === 0 ? 'keep-local' : 'use-remote';
  return input.remoteRevision <= input.baseRevision ? 'keep-local' : 'use-remote';
}
